import {CardType, DefaultHumidifierValues, TaskType} from 'constants/dataEnum';
import {addCardTask, removeCard, setHumidityLevel} from 'stores/actions/cardStateAction';
import {find} from 'lib/objectHelper';
import {generateCardIDAndTaskIDAndNumber} from './commonTaskListBusiness';

export const addHumidifierCardAndTask = () => (dispatch, getState) => {
  const state = getState();
  const {cardState} = state;
  const {cards, tasks} = cardState;
  const cardType = CardType.ENABLE_HUMIDIFIER;
  const cardName = 'Humidifier';
  const [cardID, taskID, taskNumber] = generateCardIDAndTaskIDAndNumber(cards, tasks, cardType, null);
  const humidifierTask = find(tasks, {type: TaskType.ENABLE_HUMIDIFIER});
  const task = {
    ID: taskID,
    number: taskNumber,
    type: TaskType.ENABLE_HUMIDIFIER,
    humidityLevel: humidifierTask?.humidityLevel ?? DefaultHumidifierValues.HUMIDITIY_LEVEL,
    humidifierTimeout: humidifierTask?.humidifierTimeout ?? DefaultHumidifierValues.HUMIDIFIER_TIMEOUT,
  };

  dispatch(addCardTask(cardID, cardName, cardType, task.ID, task));
};

export const removeHumidiferCardAndTask = () => (dispatch, getState) => {
  const state = getState();
  const {cardState} = state;
  const {cards} = cardState;
  const humidifierCard = find(cards, {type: TaskType.ENABLE_HUMIDIFIER});

  if (humidifierCard) dispatch(removeCard(humidifierCard.ID));
};

export const updateHumidityLevel = (humidityLevel) => (dispatch, getState) => {
  const state = getState();
  const {cardState} = state;
  const {tasks} = cardState;
  const humidifierTask = find(tasks, {type: TaskType.ENABLE_HUMIDIFIER});

  if (humidifierTask) dispatch(setHumidityLevel(humidifierTask.ID, humidityLevel));
};
